import { readErrorBody } from "../util/apiErrorMessage";

const failure = (message) => ({ ok: false, message });

export const subscribeToNewsletter = ({ email, source, location }) =>
  fetch("/api/newsletterEmail", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ email, source, location }),
  })
    .then((response) =>
      response.ok
        ? { ok: true }
        : readErrorBody(response).then(({ message }) => failure(message)),
    )
    .catch(() => failure(undefined));
